const Config: any = {
  BaseUrlDev: import.meta.env.REACT_APP_API_URL_DEV,
  BaseUrlProd: import.meta.env.REACT_APP_API_URL_PROD,
  ApiKey: import.meta.env.REACT_APP_X_API_KEY,
  BaseUrlPickupStudentDev: import.meta.env.REACT_APP_PICKUP_STUDENT_DEV,
  BaseUrlPickupStudentProd: import.meta.env.REACT_APP_PICKUP_STUDENT_PROD,
  BaseUrlViolationPointDev: import.meta.env.REACT_APP_VIOLATION_POINT_DEV,
  BaseUrlViolationPointProd: import.meta.env.REACT_APP_VIOLATION_POINT_PROD,
  BaseUrlAttendanceProDev: import.meta.env.REACT_APP_ATTENDANCE_PRO_DEV,
  BaseUrlAttendanceProProd: import.meta.env.REACT_APP_ATTENDANCE_PRO_PROD,
  BaseUrlJournalDev: import.meta.env.REACT_APP_JOURNAL_DEV,
  BaseUrlJournalProd: import.meta.env.REACT_APP_JOURNAL_PROD,
  BaseUrlRecitationDev: import.meta.env.REACT_APP_RECITATION_DEV,
  BaseUrlRecitationPro: import.meta.env.REACT_APP_RECITATION_DEV,
  BaseUrlMedicalRecordDev: import.meta.env.REACT_APP_MEDICAL_RECORD_DEV,
  BaseUrlMedicalRecordPro: import.meta.env.REACT_APP_MEDICAL_RECORD_DEV,
  BaseUrlPerizinanDev: import.meta.env.REACT_APP_PERIZINAN_DEV,
};
let baseUrl = "";
export const check = () => {
  if (import.meta.env.PROD) {
    baseUrl = Config.BaseUrlProd;

    // remove consoles in production
    console.log = () => {};
    console.debug = () => {};
    console.info = () => {};
    console.warn = () => {};
  } else {
    baseUrl = Config.BaseUrlDev;
  }
  return baseUrl;
};
export default Config;
